import { render } from "./VideoPage.vue?vue&type=template&id=061ef256&ts=true"
import script from "./VideoPage.vue?vue&type=script&lang=ts"
export * from "./VideoPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/HeThongPVNB_HV/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__